import { reactive } from "vue";
import { Subject } from "rxjs";
import type { phoneBlockForm } from "@/core/core";

// https://vuejs.org/guide/scaling-up/state-management.htm
// https://vuejs.org/guide/extras/reactivity-in-depth.html

export const AppService = reactive({
  popup: null,
  popupClosing: false,
  popupData: {} as any,
  phoneBlockLoading: false,
  faqSubject: new Subject<any>(),

  phoneBlockSubject: new Subject<phoneBlockForm>(),
  phoneBlockSubjectResult: new Subject<any>(),

  isJsonString(data: string) {
    try {
      JSON.parse(data);
    } catch (e) {
      return false;
    }
    return true;
  },
  openPopup(slug: string, data: any = null, addLink = false) {
    if (data) {
      if (this.isJsonString(data)) {
        this.popupData = JSON.parse(data);
      } else {
        this.popupData = data;
      }
    }

    this.popupData.add_link = addLink;

    this.popup = slug;
    const scrollbarWidth = window.innerWidth - document.body.clientWidth + "px";
    document.body.classList.add("popup-scroll-block");
    document.body.style.paddingRight = scrollbarWidth;
    document.getElementById("header").style.right = scrollbarWidth;
  },
  closePopup() {
    this.popupClosing = true;
    setTimeout(() => {
      document.body.classList.remove("popup-scroll-block");
      document.body.style.paddingRight = "0";
      document.getElementById("header").style.right = "0";
      this.popupClosing = false;
      this.popup = null;
    }, 150);
  },
  openFAQ(item: any) {
    this.faqSubject.next(item);
  },
});
